














































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  Fornecedor,
  FornecedoresService,
} from "@/services/fornecedores.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { fileToBase64 } from "@/shared/utils/utils";
import { required } from "@/shared/validators";

interface Hierarquia {
  ehHolding: boolean;
  idFornecedorHolding: string | null;
}

@Component({
  components: {
    Loading,
    Modal,
  },
})
export default class Manter extends Vue {
  fornecedor: Fornecedor | null = null;
  valid = false;
  loading = false;
  erroDescricao = false;
  arquivoLogo = {} as File;
  todasHoldings: Fornecedor[] = [];
  hierarquiaSalva: Hierarquia = { ehHolding: false, idFornecedorHolding: null };
  rules = {
    nome: [required()],
    cor: [required()],
    imagem: [required()],
  };

  required = (v: unknown) => {
    return !!v || "Campo obrigatório";
  };

  get tituloManter(): string {
    if (this.fornecedor) {
      const alvo = this.fornecedor.ehHolding ? "Holding" : "Fornecedor";
      return this.fornecedor.idFornecedor == null
        ? `Nova ${alvo}`
        : `Alterar ${alvo}`;
    }
    return "";
  }

  get holdings(): Fornecedor[] {
    if (!this.fornecedor) {
      return this.todasHoldings;
    }
    return this.todasHoldings.filter(
      (x) => x.idFornecedor !== this.fornecedor?.idFornecedor
    );
  }

  // Sem isso, marcar "é uma holding" num fornecedor ja agrupado manteria o vinculo
  // escondido pelo v-if e o servidor recusaria com uma mensagem sobre agrupamento,
  // que nao tem relacao com o que a pessoa acabou de fazer na tela.
  onEhHoldingChange(ehHolding: boolean) {
    if (ehHolding && this.fornecedor) {
      this.fornecedor.idFornecedorHolding = null;
    }
  }

  @Watch("arquivoLogo")
  onArquivoChange() {
    if (this.fornecedor && this.arquivoLogo.name) {
      this.fornecedor.logo = URL.createObjectURL(this.arquivoLogo);
      this.fornecedor.logoCompleta = this.fornecedor.logo;
    }
  }

  async salvarFornecedor() {
    const form = this.$refs.form as any;

    this.erroDescricao = false;
    if (!form.validate() || !this.fornecedor) {
      return;
    }

    this.loading = true;
    try {
      const base64 = await fileToBase64(this.arquivoLogo);
      await FornecedoresService.manterFornecedor(this.fornecedor, base64);
    } catch {
      // O interceptor do axios ja exibiu a mensagem do servidor. Desfazer so o switch e o
      // vinculo -- o que a recusa fala sobre -- devolve a tela ao estado gravado sem jogar
      // fora o nome e a cor que a pessoa acabou de digitar.
      this.fornecedor.ehHolding = this.hierarquiaSalva.ehHolding;
      this.fornecedor.idFornecedorHolding = this.hierarquiaSalva.idFornecedorHolding;
      return;
    } finally {
      // Sem isto o modal fica preso no loader: com :loading ativo ele esconde o proprio
      // rodape, e o v-dialog persistent nao fecha por ESC nem por clique fora.
      this.loading = false;
    }

    return this.fechar();
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    this.arquivoLogo = {} as File;
    return modal.close(false);
  }

  public async editarFornecedor(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    try {
      const [fornecedor, holdings] = await Promise.all([
        FornecedoresService.obter(id),
        FornecedoresService.listarHoldings(),
      ]);
      // idFornecedorHolding vem ausente do JSON quando e nulo (NullValueHandling.Ignore) e o
      // Vue 2 nao torna reativa uma chave que nao existia no objeto atribuido -- sem este
      // default o v-select gravaria o valor sem a tela acompanhar.
      this.fornecedor = { idFornecedorHolding: null, ...fornecedor };
      this.todasHoldings = holdings;
      this.hierarquiaSalva = {
        ehHolding: this.fornecedor.ehHolding,
        idFornecedorHolding: this.fornecedor.idFornecedorHolding ?? null,
      };
    } catch {
      this.fechar();
    } finally {
      this.loading = false;
    }

    return p;
  }

  public async novoFornecedor(ehHolding = false) {
    const modal = this.$refs.modal as Modal;
    this.fornecedor = {
      nome: "",
      cor: "#808080",
      excluido: false,
      tipo: "FornecedorGlobal",
      ehHolding,
      idFornecedorHolding: null,
    } as Fornecedor;
    this.hierarquiaSalva = { ehHolding, idFornecedorHolding: null };

    const p = modal.open();
    this.todasHoldings = await FornecedoresService.listarHoldings();

    return p;
  }
}
